export const ModalActiveThemeAppExtension = {
  modal_heading: "Veda Builder n'est pas activé !",
  modal_content_title:
    "Les données de la page ont été enregistrées dans Veda. Mais vous devez activer l'application pour mettre à jour les modifications dans votre boutique.",
  modal_content_description: 'Cliquez sur le bouton "Activer l\'application" pour activer l\'application Veda Builder.',
  modal_button: "Activer l'application",
};
